import { BatchHistoryTable } from '../components/BatchHistoryTable';
import { HistoricalTable } from '../components/HistoricalTable';

export function HistoryPage() {
  return (
    <div className="space-y-6">
      <BatchHistoryTable />
      <HistoricalTable />
    </div>
  );
}
